import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";

const APPEALS_URL = "/services/rcp/profile/appeals/";
const specialistGuarantessUrl =
  "/services/rcp/profile/appeals/specialistguarantees/";
const medUrl = "/services/rcp/profile/appeals/medambguarantees/";
const hospitalUrl = "/services/rcp/profile/appeals/hospitalguarantees/";
export function* getdashboardAppeals() {
  yield takeLatest(CONSTANTS.GET_MAIN_DASHBOARD_APPEALS, function* (action) {
    try {
      yield put(actions.setdashboardAppeals(null));

      const url =
        APPEALS_URL + "GetdashboardAppeals?policyId=" + action.payload;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const data = res.data;

      yield put(actions.setdashboardAppeals(data));
    } catch (e) {
      yield put(actions.setdashboardAppeals([]));
      console.error(e);
    }
  });
}
export function* getShowSpecialistPopup() {
  yield takeLatest(CONSTANTS.GET_SHOW_SPECIALIST_POPUP, function* () {
    try {
      yield put(actions.setShowSpecialistPopup(false));

      const url = specialistGuarantessUrl + "ShowSpecialistPopup";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data?.showPopup;

      yield put(actions.setShowSpecialistPopup(data));
    } catch (e) {
      yield put(actions.setShowSpecialistPopup(false));
      console.error(e);
    }
  });
}
export function* getExtendAppeal() {
  yield takeLatest(CONSTANTS.GET_EXTEND_APPEAL, function* (action) {
    let errorStatus = "";
    try {
      yield put(actions.setExtendAppeal(undefined));
      const urlTypes = {
        Ambulatory: `${medUrl}ExtendAmbTerm`,
        Specialist: `${specialistGuarantessUrl}ExtendSpecTerm`,
        Hospital: `${hospitalUrl}ExtendHospTerm`,
      };
      const errorTypesArray = {
        Ambulatory: {
          955: "dashboardAppeals.ReferralIsActive",
          956: "dashboardAppeals.referralIsAlreadyExtended",
          957: "dashboardAppeals.cannotBeExtended",
          958: "dashboardAppeals.extensionDeadlineHasExpired",
          959: "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations",
          960: "dashboardAppeals.serviceLimitHasExpired",
          961: "dashboardAppeals.requestNewAppeal",
          404: "dashboardAppeals.recordNotFound",
        },
        Specialist: {
          554: "dashboardAppeals.ReferralIsActive",
          555: "dashboardAppeals.referralIsAlreadyExtended",
          556: "dashboardAppeals.cannotBeExtended",
          557: "dashboardAppeals.extensionDeadlineHasExpired",
          558: "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations",
          960: "dashboardAppeals.serviceLimitHasExpired",
          961: "dashboardAppeals.requestNewAppeal",
          404: "dashboardAppeals.recordNotFound",
        },
        Hospital: {
          366: "dashboardAppeals.guaranteeIsactive",
          367: "dashboardAppeals.guaranteeIsextended",
          368: "dashboardAppeals.guaranteeIsused",
          369: "dashboardAppeals.guaranteeIsexpired",
          370: "dashboardAppeals.policiesExpired",
          371: "dashboardAppeals.errorCommunicatingWithEmailSenderService",
          1702: "dashboardAppeals.toAddressIsRequired",
          404: "dashboardAppeals.recordnotfound",
        },
      };

      const urlComputed = urlTypes?.[action?.payload?.type];
      const computedPayload =
        action?.payload?.type === "Hospital"
          ? { guaranteeId: action.payload?.id }
          : { medGuaranteesAmbId: action.payload?.id };
      const res = yield window.mainAxios
        .post(urlComputed, computedPayload)
        .then((x) => x.data)
        .catch(function (error) {
          if (error?.response) {
            // The request was made and the server responded with a status code      // that falls out of the range of 2xx

            const errorTypes = errorTypesArray?.[action?.payload?.type];
            if (
              errorTypes?.[error.response?.data?.ExceptionCode] !== undefined
            ) {
              errorStatus = errorTypes?.[error.response?.data?.ExceptionCode];
              // dispatch(actions.setValidateFilesMessage("compensations.fileSizeTooBigText"))
            } else {
              errorStatus = "";
              // dispatch(actions.setValidateFilesMessage("compensations.fileSizeNotValidated"))
            }
          } else if (error.request) {
            // The request was made but no response was received      // `error.request` is an instance of XMLHttpRequest in the browser       // and an instance of http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }
        });

      const error = {
        exceptionCode: res.exceptionCode,
        exceptionMessage: res.exceptionMessage,
      };
      if (!res.success) throw error;
      yield put(
        actions.setExtendAppeal({
          status: true,
          message: res.data,
          isHospital: action?.payload?.type === "Hospital",
        })
      );
    } catch (e) {
    } finally {
      if (errorStatus !== "") {
        yield put(actions.setExtendAppeal(errorStatus));
      }
    }
  });
}
export default function* appealsSaga() {
  yield all([
    fork(getdashboardAppeals),
    fork(getShowSpecialistPopup),
    fork(getExtendAppeal),
  ]);
}
